import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCurrencies,
  getStatus,
  getPaymentTerms,
  getDefaultCarrier,
  getTaxRule
} from '../../../redux/slices/entitySlice';
import CustomInput from '../../CustomInput';
import CustomSelect from '../../CustomSelect';
import TabsWrapper from './TabsWrapper';
import { getSuppliers } from '../../../redux/slices/supplierSlice';


const AddNewSupplier = () => {
  const dispatch = useDispatch();
  const [supplierCreated, setSupplierCreated] = useState(false);

  const [suppliersList, setSuppliersList] = useState([]);

  const {
    status,
    paymentTerms,
    defaultCarrier,
    taxRule,
    currencies,
  } = useSelector((state) => state.entity);

  useEffect(() => {
    dispatch(getCurrencies())
    dispatch(getStatus())
    dispatch(getPaymentTerms())
    dispatch(getDefaultCarrier())
    dispatch(getTaxRule())
  }, []);

  console.log({currencies, status, paymentTerms, defaultCarrier, taxRule});

  const initialValues = {
    supplierName: '',
    currency: '',
    paymentTerms: '',
    taxRule: '',
    defaultCarrier: '',
    taxNumber: '',
    discount: '',
    comments: '',
    status: ''
  };

  const validationSchema = Yup.object({
    supplierName: Yup.string().required('Supplier name is required'),
    currency: Yup.string().required('Currency is required'),
    paymentTerms: Yup.string().required('Payment Terms is required'),
    taxRule: Yup.string().required('Tax rule is required'),
    status: Yup.string().required('Status is required'),
    defaultCarrier: Yup.string().required('Default Carrier is required'),
    taxNumber: Yup.string(),
    comments: Yup.string(),
  });

  const handleFormSubmit = (values) => {
    console.log('Form Submitted:', values);
    setSupplierCreated(true);
  };

  const getSuppliersList = async() => {
    try {
      const response = await dispatch(getSuppliers()).unwrap();
      setSuppliersList(response.data.map(item => item.name));
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getSuppliersList();
  }, [])

  return (
    <Box sx={{ paddingX: 0, paddingY: 1 }}>
      <div style={{ backgroundColor: "white", borderRadius: "10px" }}>
        <Box sx={{
          display: "flex", justifyContent: "space-between", alignItems: "center",
          borderBottom: "1px solid #38535E", padding: "10px"
        }}>
          <Typography sx={{ fontSize: "16px" }}>NEW SUPPLIER</Typography>
        </Box>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit = {handleFormSubmit}
        >
          {({ values, errors, touched, handleChange, handleSubmit }) => {
          return (
            <form onSubmit={handleSubmit} style={{ padding: 10 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={4}>
                  <CustomSelect
                    label="Supplier Name"
                    name="supplierName"
                    required
                    value={values.supplierName}
                    data={suppliersList}
                    handleChange={handleChange}
                    searchable={true}
                    error={touched.supplierName && Boolean(errors.supplierName)}
                    helperText={touched.supplierName && errors.supplierName}
                    height={40}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={4}>
                  <CustomSelect
                    label="Tax Rule"
                    name="taxRule"
                    required
                    value={values.taxRule}
                    handleChange={handleChange}
                    data={taxRule}
                    searchable={true}
                    options={taxRule}
                    error={touched.taxRule && Boolean(errors.taxRule)}
                    helperText={touched.taxRule && errors.taxRule}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={4}>
                  <CustomInput
                    label="Discount"
                    name="discount"
                    required
                    value={values.discount}
                    onChange={handleChange}
                    error={touched.discount && Boolean(errors.discount)}
                    helperText={touched.discount && errors.discount}
                    height={40}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={4}>
                  <CustomSelect
                    label="Currency"
                    name="currency"
                    required
                    data={currencies}
                    searchable={true}
                    value={values.currency}
                    handleChange={handleChange}
                    options={currencies}
                    error={touched.currency && Boolean(errors.currency)}
                    helperText={touched.currency && errors.currency}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={4}>
                  <CustomSelect
                    label="Status"
                    name="status"
                    required
                    data={status}
                    value={values.status}
                    searchable={true}
                    handleChange={handleChange}
                    options={status}
                    error={touched.status && Boolean(errors.status)}
                    helperText={touched.status && errors.status}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={4}>
                  <CustomSelect
                    label="Payment Terms"
                    name="paymentTerms"
                    // required
                    value={values.paymentTerms}
                    data={paymentTerms}
                    handleChange={handleChange}
                    searchable={true}
                    options={paymentTerms}
                    error={touched.paymentTerms && Boolean(errors.paymentTerms)}
                    helperText={touched.paymentTerms && errors.paymentTerms}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={4}>
                  <CustomSelect
                    label="Default Carrier"
                    name="defaultCarrier"
                    searchable={true}
                    required
                    value={values.defaultCarrier}
                    data={defaultCarrier}
                    handleChange={handleChange}
                    options={defaultCarrier}
                    error={touched.defaultCarrier && Boolean(errors.defaultCarrier)}
                    helperText={touched.defaultCarrier && errors.defaultCarrier}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={4}>
                  <CustomInput
                    label="Tax Number"
                    name="taxNumber"
                    value={values.taxNumber}
                    
                    onChange={handleChange}
                    error={touched.taxNumber && Boolean(errors.taxNumber)}
                    helperText={touched.taxNumber && errors.taxNumber}
                    height={40}
                  />
                </Grid>

                <Grid item xs={12}>
                  <CustomInput
                    label="Comments"
                    name="comments"
                    value={values.comments}
                    onChange={handleChange}
                    type="text"
                    placeholder="Write your Notes Here..."
                    error={touched.comments && Boolean(errors.comments)}
                    helperText={touched.comments && errors.comments}
                    height={100}
                  />
                </Grid>
              </Grid>

              <Box sx={{ mt: 3 }}>
                <button type="submit" style={{
                  padding: "8px 20px", background: "#d6dcf8",
                  color: "black", border: "none", borderRadius: 4
                }}>
                  Save Supplier
                </button>
              </Box>
            </form>
          )
          }}
        </Formik>
      </div>

      <TabsWrapper isSupplierCreated={supplierCreated} />
    </Box>
  );
};

export default AddNewSupplier;